//------------------
// get slot details
//------------------
export default function getSlotDetails(slot) {
  var prefix = slot.substr(0, 2);
  var num = Number(slot.substr(2, 1));
  return [prefix, num];
}
